import React from "react";
import "./Faq.scss";

// components
import Button from "../../coraWebComponents/buttons/Button";

class Faq extends React.Component {
  constructor(props) {
    super(props);
    
    this.questions = [
      { 
        question: `Ako správne pracovať s portálom?`,
        answer: `Príručka je dostupná prostredníctvom odkazu na hlavnej stránke (v metodických postupoch), alebo v menu používateľa - v pravom hornom rohu.` 
      }, { 
        question: `Ako môžem zadať novú žiadosť?`,
        answer: `Zadanie novej žiadosti uskutočníte prostredníctvom voľby „Podať žiadosť“.  Ďalší postup zadania žiadosti je navigovaný postupnými krokmi tzv. „Sprievodcu“  a bublinkovou nápoveďou.` 
      }, { 
        question: `Pri zadávaní adresy som zistil, že súpisné číslo (*CS) je povinné, čo ak ho stavba nemá?`,
        answer: `V prípade novostavby uveďte hodnotu "0".` 
      }, { 
        question: `Ako vyznačím v mape záujmové územie?`,
        answer: `Zvoľte nástroj (ikona s ceruzou) a kliknutím do mapy vyznačte polygón, ktorý reprezentuje vašu oblasť záujmu (voľný polygón). Zadávanie bodov/posledný bod ukončíte dvojitým kliknutím do mapy. Ak polygón nie je zakreslený, potvrdením voľby „Ďalej“ sa automatizovane vygeneruje oblasť záujmu v rozsahu aktuálneho  mapového pohľadu.` 
      }, { 
        question: `Je možné zadaný polygón upraviť?`,
        answer: `Áno, je to možné. Zakreslený polygón má oranžovú farbu, po ďalšom kliknutí naň sa zmení na modrý. V tomto režime je možné  vrcholy uchopiť a posúvať. Zároveň je možné klikom na hranu vytvoriť nové body polygónu.` 
      }, { 
        question: `S polygónom nie som spokojný, je možné ho zadať nanovo?`,
        answer: `Áno, nesprávny polygón zmažeme prostredníctvom ikony „Krok späť“ (posledný nástroj mapového okna), zvolíme nástroj na zákres polygónu (ikona s ceruzou) a kliknutím do mapy vytvoríme nový.` 
      }, { 
        question: `Ako môžem zadať doplňujúce údaje?`,
        answer: `Slovné spresnenie žiadosti odporúčame uviesť v 6. kroku  „Prílohy a komentáre“ a doplňujúce podklady  nahrať vo forme samostatných príloh.` 
      }, { 
        question: `Ako zistím, či som žiadosť úspešne zadal?`,
        answer: `Úspešne zadaná žiadosť je potvrdená hláškou portálu, ale aj emailovou notifikáciou na váš registračný email. Rovnako je tomu aj pri vystavení samotného Vyjadrenia k žiadosti.` 
      }, { 
        question: `Ak som informovaný o publikovaní Vyjadrenia k žiadosti, v ktorej časti portálu ho nájdem?`,
        answer: `Vyjadrenie a súvisiace prílohy sú stiahnuteľné v sekcii Moje žiadosti.`
      },
    ];
  }

  contactZakCentrum = (e) => {};

  render() {
    return (
      <div className="row m-0 faq" style={{ height: "100%" }}>
        <div className="col p-4">
          <div className="row m-0">
            <div className="col p-0 faqTitle">
              Otázky a odpovede.
            </div>
          </div>
          <div className="row m-0 pt-3">
            <div className="col p-0">
                <ul className="questions">
                  {this.questions.map((q, qKey) => {
                    return (
                      <li
                        key={qKey}
                        className="question"
                        dangerouslySetInnerHTML={{ __html: ` <b>${q.question}</b><br/>${q.answer}`}}
                      />
                    );
                  })}
                </ul>
            </div>
          </div>
          {/* FOOTER */}
          <div className="row m-0 pt-3">
            <div className="col p-0 homeFooterText">
              <span>Nenašli ste odpoveď na vaše otázky?</span>
            </div>
            <div className="col p-0 homeFooterButton">
              <Button
                label="Kontaktujte zákaznícke centrum"
                className="homeContactButton"
                onClick={this.contactZakCentrum}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Faq;
